

<div class="container-fluid profile-bar">
    <div class="container">

        <div class="w-100 d-flex justify-content-center  mt-2" *ngIf="object?.parent">
            <p-button size="small" [routerLink]="'/list-services/'+object?.parent.id+'/'+type"
            [badge]="object?.parent.data_counter[type]" 
            [label]="object?.parent.name"
            (click)="applyFilter()"
            styleClass="text-nowrap inlines py-4"
            routerLinkActive="active" >
                <img *ngIf="checkisImg(object?.parent.image); else elseBlock" src="{{siteUrl}}{{object?.parent.image}}" class="img-fluid" 
                    style="width: 20px; margin-left: 10px;" alt="{{object?.parent.name}}">
                <ng-template #elseBlock>
                    <i style="margin-left: 10px;" class="{{object?.parent.image}}"></i>
                </ng-template>
            </p-button>
        </div>

        <div class="w-100 d-flex justify-content-center  mt-2"
        *ngIf="object && object.data_counter && object.data_counter[type]">
            <p-button size="small" [routerLink]="'/list-services/'+object?.id+'/'+type" 
            [badge]="object.data_counter[type]"
            (click)="applyFilter()"
            styleClass="text-nowrap inlines py-4"
            routerLinkActive="active" [label]="object?.name" > 
                <img *ngIf="checkisImg(object?.image); else elseBlock" src="{{siteUrl}}{{object?.image}}" class="img-fluid" 
                    style="width: 20px; margin-left: 10px;" alt="{{object?.name}}">
                <ng-template #elseBlock>
                    <i style="margin-left: 10px;" class="{{object?.image}}"></i>
                </ng-template>
            </p-button>

            <p-button size="small" *ngIf="notObject && notObject.data_counter && notObject.data_counter > 0"
            [badge]="notObject.data_counter.toString()"
            (click)="applyFilter()"
            styleClass="text-nowrap inlines py-4"
            routerLinkActive="active" [label]="notObject?.name" > 
                    <i style="margin-left: 10px;" class="{{notObject?.image}}"></i>
            </p-button>
        </div>

        <div class="row flex-wrap justify-content-center mt-2" *ngIf="object && object?.children && object?.children.length > 0">
            <ng-container *ngFor="let child of object.children">
                <div class="col-3 mt-2" *ngIf="child.data_counter[type] && child.data_counter[type] > 0">
                    <p-button
                        size="small"
                        styleClass="text-wrap outlines w-100 h-100" class="w-100 h-100"
                        [routerLink]="'/list-services/' + child?.id + '/' + type"
                        routerLinkActive="active"
                        [badge]="child.data_counter[type]"
                        [label]="child?.name"
                        (click)="applyFilter()"
                    >
                    <img *ngIf="checkisImg(child?.image); else elseBlock" src="{{siteUrl}}{{child?.image}}" class="img-fluid" 
                    style="width: 20px; margin-left: 10px;" alt="{{child?.name}}">
                    <ng-template #elseBlock>
                        <i style="margin-left: 10px;" class="{{child?.image}}"></i>
                    </ng-template>
                    </p-button>
                </div>
            </ng-container>
        </div>

        <!-- Add the PrimeNG input for filtering -->
        <div class="flex flex-column gap-2  mt-4 pt-2">
            <span class="p-input-icon-right w-100">
                <i class="pi pi-search"></i>
                <input pInputText [(ngModel)]="filterText" (input)="applyFilter()" [placeholder]="'ابحث عن '+ type +' ...'" class="full-width-input p-inputtext-lg">
            </span>
            
        </div>
        
        
    </div>
</div>


<div class="container">

    <div class="row">
        <div *ngFor="let item of filterItems" class="col-12 col-sm-6 col-md-4 my-2 py-2">
            <div class="card itemview p-5">
                <div class="card-body">


                    <ng-container *ngIf="object.children.length > 0; else parentBlock">


                        <ng-container *ngFor="let child of object.children">

                            <ng-container *ngIf="itemHasOus(child.id, item.ous)">


                                <div class="d-flex">
                                    <img *ngIf="checkisImg(child.image); else elseBlock" src="{{siteUrl}}{{child.image}}"
                                        class="img-fluid p-1" style="max-height: 30px; max-width: 30px;">
                                    <ng-template #elseBlock>
                                        <i class="{{child.image}} p-2" style="font-size: 1rem;"></i>
                                    </ng-template>
                                    <b class="text-wrap">{{ child.name }} </b>
                                </div>

                            </ng-container>
                            

                        </ng-container>

                    </ng-container>

                    <ng-template #parentBlock>

                        <div class="d-flex">
                            <img *ngIf="checkisImg(object.image); else parentelseBlock" src="{{siteUrl}}{{object.image}}"
                                class="img-fluid p-1" style="max-height: 30px; max-width: 30px;">
                            <ng-template #parentelseBlock>
                                <i class="{{object.image}} p-2" style="font-size: 1rem;"></i>
                            </ng-template>
                            <b class="text-wrap">{{ object.name | highlight: filterText }}</b>
                        </div>

                    </ng-template>
                    

                    <h4 [innerHTML]="item.name  | highlight: filterText"></h4>

                    <div class="d-flex pt-2">
                        <p-button [routerLink]="'/data/'+item.id" label='{{"the details" | translator}}' [icon]="'pi pi-search'" ></p-button>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="filterItems && filterItems.length < 1">

            <div class="container-fluid" style="min-height: 400px;">
                <div class="container d-flex justify-content-center">
                    <h5 class="la-tujad mt-5 pt-5">{{"There is no data" | translator}}<i
                            class="pi pi-fw pi-exclamation-triangle font-2rem mx-2"></i></h5>
                </div>
            </div>

        </div>
    </div>

</div>
